import styled from '@emotion/styled';

import { colors } from '../../ui';

const FAQButton = styled('div')(({ active }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 25,
  borderRadius: 4,
  cursor: 'pointer',
  fontFamily: 'Open Sans',
  fontWeight: 600,
  fontSize: 18,
  lineHeight: '30px',
  color: active ? '#fff' : '#000',
  borderStyle: 'solid',
  borderColor: active ? colors.blue : colors.grayDark,
  borderWidth: 1,
  transition: 'all .2s',
  background: active ? colors.blue : '#fff',
  pointerEvents: active ? 'none' : 'all',
  ':hover': {
    borderColor: colors.blue,
    background: colors.blue,
    color: '#fff',
  },
}));

export default FAQButton;
